<template>
  <div class="customer-projects-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>所属项目查看</span>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
        v-model="searchParams.projectName"
        placeholder="项目名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-select
        v-model="searchParams.progress"
        placeholder="项目形象进度"
        clearable
        class="search-input"
      >
        <el-option
          v-for="item in progressOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      
      <el-input
        v-model="searchParams.workerCount"
        placeholder="在场人数"
        clearable
        class="search-input"
        type="number"
      ></el-input>
      
      <el-input
        v-model="searchParams.manager"
        placeholder="项目经理"
        clearable
        class="search-input"
      ></el-input>
      
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
    </div>
    
    <!-- 项目列表 -->
    <el-table
      :data="projectList"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        prop="projectName"
        label="项目名称"
        min-width="300"
      ></el-table-column>
      
      <el-table-column
        prop="progress"
        label="项目形象进度"
        width="150"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="workerCount"
        label="在场人数"
        width="100"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="area"
        label="建筑面积(㎡)"
        width="150"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="contractor"
        label="总包单位"
        min-width="250"
        align="center"
      ></el-table-column>
      
      <el-table-column
        prop="manager"
        label="项目经理"
        width="120"
        align="center"
      ></el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerProjects',
  data() {
    return {
      searchParams: {
        projectName: '',
        progress: '',
        workerCount: '',
        manager: ''
      },
      progressOptions: [
        { value: '装饰', label: '装饰' },
        { value: '主体', label: '主体' },
        { value: '基础', label: '基础' },
        { value: '完工', label: '完工' }
      ],
      loading: false,
      projectList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 模拟数据
      mockData: [
        {
          id: 1,
          projectName: '大北区三组团片区综合开发项目（一期）',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 2,
          projectName: '大北区三组团片区综合开发项目（公服）',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 3,
          projectName: '绿色建材科技产业示范基地项目办公楼室内装饰工程专业',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 4,
          projectName: '分包工程',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 5,
          projectName: '成华区东广人工智能谷二期项目(一期)施工/标段临时设施',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 6,
          projectName: '装修',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 7,
          projectName: '重庆中建·光年项目ALC条板工程',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 8,
          projectName: '华润中央公园悦府项目ALC条板工程',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 9,
          projectName: '龙兴组团分区I13地块、107 地块幼儿园及I14地块ALC条板工程',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        },
        {
          id: 10,
          projectName: '芦山龙门溶洞',
          progress: '装饰',
          workerCount: 3,
          area: 20097,
          contractor: '四川省第三建筑工程有限公司',
          manager: '秦订单'
        }
      ]
    };
  },
  created() {
    this.getProjectList();
  },
  methods: {
    // 获取项目列表
    getProjectList() {
      this.loading = true;
      
      // 模拟API请求
      setTimeout(() => {
        // 过滤数据
        let filteredData = this.mockData.filter(item => {
          const nameMatch = item.projectName.includes(this.searchParams.projectName);
          const progressMatch = !this.searchParams.progress || item.progress === this.searchParams.progress;
          const workerMatch = !this.searchParams.workerCount || item.workerCount.toString() === this.searchParams.workerCount;
          const managerMatch = !this.searchParams.manager || item.manager.includes(this.searchParams.manager);
          
          return nameMatch && progressMatch && workerMatch && managerMatch;
        });
        
        // 设置总数
        this.pagination.total = filteredData.length;
        
        // 分页
        const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
        const end = start + this.pagination.pageSize;
        this.projectList = filteredData.slice(start, end);
        
        this.loading = false;
      }, 500);
      
      // 实际项目中这里应该调用API获取数据
      // this.$axios.get('/api/customer/projects', {
      //   params: {
      //     projectName: this.searchParams.projectName,
      //     progress: this.searchParams.progress,
      //     workerCount: this.searchParams.workerCount,
      //     manager: this.searchParams.manager,
      //     page: this.pagination.currentPage,
      //     pageSize: this.pagination.pageSize
      //   }
      // }).then(response => {
      //   this.projectList = response.data.list;
      //   this.pagination.total = response.data.total;
      //   this.loading = false;
      // }).catch(error => {
      //   this.$message.error('获取项目列表失败');
      //   this.loading = false;
      // });
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getProjectList();
    },
    
    // 页码改变
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getProjectList();
    },
    
    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.currentPage = 1;
      this.getProjectList();
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-projects-container {
  padding: 20px;
  background-color: #fff;
  
  .page-header {
    margin-bottom: 20px;
    
    .header-title {
      display: flex;
      align-items: center;
      
      .title-mark {
        width: 4px;
        height: 18px;
        background-color: #2c73eb;
        margin-right: 8px;
      }
      
      span {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
  
  .search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .search-input {
      width: 220px;
      margin-right: 15px;
      margin-bottom: 10px;
    }
    
    .el-button {
      padding: 11px 20px;
      margin-bottom: 10px;
    }
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style> 